import React, { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import { encode } from "base-64";
import ReCAPTCHA from "react-google-recaptcha";
import { Container, Row, Col } from "react-bootstrap";
import { useGoogleLogin } from "react-google-login";
import CircularProgress from "@material-ui/core/CircularProgress";
// IMAGE
import google from "../assets/images/google-icon.svg";
import logo from "../assets/images/logo2.svg";
import eye from "../assets/images/eye.png";
import hide from "../assets/images/noteye.png";
import { authAction } from "./authActions";
import {
  GOOGLE_CLIENT_ID,
  GOOGLE_RECAPTCHA_SITE_KEY,
  LOGO_PATH,
  MAIN_URL,
  PASSWORD_LENGTH,
  PROJECT_NAME,
} from "../config";
const cookies = new Cookies();
function Signup() {
  const history = useHistory();
  var token = cookies.get("wmtoken");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [institution, setInstitution] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [hearAbout, setHearAbout] = useState("");
  const [roles, setRoles] = useState([]);
  const [bio, setBio] = useState("");
  const [instaHandle, setInstaHandle] = useState("");
  const [portfolioLink, setPortfolioLink] = useState("");
  const [workSample1, setWorkSample1] = useState("");
  const [workSample2, setWorkSample2] = useState("");
  const [isGettingRegister, setIsGettingRegister] = useState(false);
  // const [googledata, setGoogleData] = useState("");
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [service, setService] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [action, setAction] = useState("");
  const [answerData, setAnswerData] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setService(urlParams.get("service"));
    setRedirectURL(urlParams.get("metaURL"));
    setAction(urlParams.get("action"));
    setAnswerData(urlParams.get("aData"));
  });
  const [captaToken, setCaptaToken] = useState("");
  const [errorMes, setErrorMes] = useState("");
  function onChange(value) {
    setCaptaToken(value);
    setErrorMes("");
  }

  // Handle role checkbox changes
  const handleRoleChange = (role) => {
    setRoles((prevRoles) => {
      if (prevRoles.includes(role)) {
        return prevRoles.filter((r) => r !== role);
      } else {
        return [...prevRoles, role];
      }
    });
  };

  // Handle bio word count
  const handleBioChange = (e) => {
    const words = e.target.value.trim().split(/\s+/);
    if (words.length <= 100 || e.target.value === "") {
      setBio(e.target.value);
    }
  };
  const signUp = (e) => {
    e.preventDefault();

    // Validate required fields
    if (
      !firstName ||
      !lastName ||
      !email ||
      !password ||
      !confirmPassword ||
      !phoneNumber ||
      !gender ||
      !city ||
      !country ||
      !dateOfBirth ||
      !hearAbout
    ) {
      alert("Please fill in all required fields");
      return;
    }

    if (roles.length === 0) {
      alert("Please select at least one role in Film/TV");
      return;
    }

    if (!bio.trim()) {
      alert("Please provide a bio");
      return;
    }

    if (captaToken) {
      setIsGettingRegister(true);
      var fd = new FormData();
      fd.append("first_name", firstName);
      fd.append("last_name", lastName);
      fd.append("email", email);
      fd.append("password", password);
      fd.append("password_confirm", confirmPassword);
      fd.append("institution", institution);
      fd.append("phone", phoneNumber);
      fd.append("gender", gender);
      fd.append("city", city);
      fd.append("country", country);
      fd.append("dob", dateOfBirth);
      fd.append("heard_from", hearAbout);
      fd.append("roles", JSON.stringify(roles));
      fd.append("bio", bio);
      fd.append("insta", instaHandle);
      fd.append("portfolio_link", portfolioLink);
      fd.append("work_sample_link_1", workSample1);
      fd.append("work_sample_link_2", workSample2);
      if (password !== confirmPassword) {
        setIsConfirmPassword(true);
        setIsGettingRegister(false);
      } else {
        axios({
          method: "POST",
          url: `${API_ENDPOINT.apiURL}Authentication/registerUser`,
          data: fd,
        })
          .then((response) => {
            if (
              response.data.message ===
              "registration request submitted successfully"
            ) {
              setIsGettingRegister(false);
              setShowSuccessModal(true);
            }
          })
          .catch((err) => {
            const { message } = err.response.data;
            console.log(message.replace(/(\r\n|\n|\r)/gm, ""));
            if (
              message.replace(/(\r\n|\n|\r)/gm, "") ===
              "The email field must contain a unique value."
            ) {
              setErrorMessage("This email address has been used already!");
            }
            setIsGettingRegister(false);
          });
      }
    } else {
      setErrorMes("Please Solve The reCaptcha");
    }
  };
  useEffect(() => {
    if (isConfirmPassword) {
      setTimeout(() => {
        setIsConfirmPassword(false);
      }, 3000);
    }
  }, [isConfirmPassword]);
  // GOOGLE SIGN IN
  const successGoogleLogin = (token, id, email, firstname, lastname, photo) => {
    var fd = new FormData();
    fd.append("idToken", token);
    fd.append("id", id);
    fd.append("email", email);
    fd.append("photo", photo);
    fd.append("first_name", firstname);
    fd.append("last_name", lastname);
    fd.append("platform", "web");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/loginGoogle`,
      data: fd,
    })
      .then((response) => {
        if (
          response.data.message === "Registration Success" ||
          response.data.message === "Login Success"
        ) {
          var encodeToken = encode(response.data.token);
          cookies.set("wmtoken", encodeToken, { domain: ".spiralbound.in" });
          // cookies.set("wmtoken", encodeToken, { path: "/" });
          if (service === null) {
            window.location.assign("/user");
          } else {
            authAction(encodeToken, service);
          }
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  // Password Word Count
  const [countBool, setCountBool] = useState(false);
  const passCount = (val) => {
    if (val.length < PASSWORD_LENGTH) {
      setCountBool(true);
    }
    if (val.length >= PASSWORD_LENGTH) {
      setCountBool(false);
    }
  };
  const userPage = () => {
    history.replace("/user");
  };
  // Password Toggle
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const clientId = GOOGLE_CLIENT_ID;
  const onFailure = (res) => {
    setIsGoogleLogin(false);
    if (res.details === "Cookies are not enabled in current environment.") {
      alert(
        'Cookies are not enabled, Please go to settings and enable "Allow all cookies"'
      );
    }
  };
  const onSuccess = (res) => {
    setIsGoogleLogin(true);
    successGoogleLogin(
      res.tokenId,
      res.googleId,
      res.profileObj.email,
      res.profileObj.givenName,
      res.profileObj.familyName,
      res.profileObj.imageUrl
    );
  };
  const { signIn } = useGoogleLogin({
    onSuccess,
    onFailure,
    clientId,
    cookiePolicy: "single_host_origin",
  });
  return (
    <>
      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <div className="bg-white rounded-lg shadow-xl p-8 max-w-md mx-4 animate-fade-in">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                <svg
                  className="h-10 w-10 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Registration Successful!
              </h3>
              <p className="text-gray-600 mb-6">
                Thank you for registering with Spiral Bound. Your account has
                been created successfully.
              </p>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
                <p className="text-sm text-blue-700">
                  <strong>Note:</strong> We will notify you once your data is
                  verified by our admin team. This usually takes 24-48 hours.
                </p>
              </div>
              <button
                onClick={() => {
                  setShowSuccessModal(false);
                  window.location.href = "/login";
                }}
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition duration-200"
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="loginBg py-5 relative z-10">
        <div className="signup px-3">
          <div className="flex justify-center mb-6">
            <img
              src={LOGO_PATH}
              alt={`${PROJECT_NAME} logo`}
              className="w-24"
            />
          </div>
          <div
            className="login_container"
            style={{ maxWidth: "900px", margin: "0 auto" }}
          >
            <div className="text-center mb-6">
              <h1 className="text-4xl font-bold mb-2">Join Spiral Bound</h1>
              <p className="text-gray-600">
                Create your account and connect with film professionals
              </p>
            </div>

            <form>
              <Container>
                {/* Personal Information Card */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                  <div className="flex items-center mb-5">
                    <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-semibold">
                      1
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-800">
                      Personal Information
                    </h2>
                  </div>

                  <Row>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="firstName"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          First Name *
                        </label>
                        <Wminput
                          type="text"
                          name="firstName"
                          required
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="lastName"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Last Name *
                        </label>
                        <Wminput
                          type="text"
                          name="lastName"
                          required
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="email"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Email Address *
                        </label>
                        <Wminput
                          type="email"
                          name="email"
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      {errorMessage && (
                        <span className="text-red-600 text-xs block mb-4">
                          {errorMessage}
                        </span>
                      )}
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="phoneNumber"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Phone Number *
                        </label>
                        <Wminput
                          type="tel"
                          name="phoneNumber"
                          required
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="dateOfBirth"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Date of Birth *
                        </label>
                        <Wminput
                          type="date"
                          name="dateOfBirth"
                          required
                          onChange={(e) => setDateOfBirth(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="gender"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Gender *
                        </label>
                        <select
                          className="border-b border-gray-300 border-solid py-2 px-1 bg-transparent outline-none"
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                          required
                        >
                          <option value="">Select</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="non-binary">Non-Binary</option>
                          <option value="prefer-not-to-say">
                            Prefer not to say
                          </option>
                        </select>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="country"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Country *
                        </label>
                        <Wminput
                          type="text"
                          name="country"
                          required
                          onChange={(e) => setCountry(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="city"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          City *
                        </label>
                        <Wminput
                          type="text"
                          name="city"
                          required
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="hearAbout"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          How did you hear about Spiral Bound? *
                        </label>
                        <select
                          className="border-b border-gray-300 border-solid py-2 px-1 bg-transparent outline-none"
                          value={hearAbout}
                          onChange={(e) => setHearAbout(e.target.value)}
                          required
                        >
                          <option value="">Select an option</option>
                          <option value="social-media">Social Media</option>
                          <option value="friend">Friend/Colleague</option>
                          <option value="search-engine">Search Engine</option>
                          <option value="film-festival">Film Festival</option>
                          <option value="advertisement">Advertisement</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4 relative">
                        <label
                          htmlFor="password"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Password ({PASSWORD_LENGTH}+ characters) *
                        </label>
                        <div className="flex border-b border-gray-300 border-solid">
                          <Wminput
                            type={`${showPassword ? "text" : "password"}`}
                            name="password_login"
                            className="border-0 flex-1"
                            onChange={(e) => {
                              setPassword(e.target.value);
                              passCount(e.target.value);
                            }}
                            required
                          />
                          <img
                            src={showPassword ? eye : hide}
                            alt="eye"
                            className="w-7 cursor-pointer"
                            style={{ filter: "opacity(0.5)" }}
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        </div>
                        {countBool && (
                          <span className="text-red-600 text-xs mt-1">
                            Password must be {PASSWORD_LENGTH}+ characters
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4 relative">
                        <label
                          htmlFor="confirmPassword"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Confirm Password *
                        </label>
                        <div className="flex border-b border-gray-300 border-solid">
                          <Wminput
                            type={`${
                              showConfirmPassword ? "text" : "password"
                            }`}
                            name="confirmPasswordRegister"
                            className="border-0 flex-1"
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                            }}
                            required
                          />
                          <img
                            src={showConfirmPassword ? eye : hide}
                            alt="eye"
                            className="w-7 cursor-pointer"
                            style={{ filter: "opacity(0.5)" }}
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          />
                        </div>
                        {isConfirmPassword && (
                          <span className="text-red-600 text-xs mt-1">
                            Passwords do not match
                          </span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Professional Information Card */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                  <div className="flex items-center mb-5">
                    <div className="bg-purple-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-semibold">
                      2
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-800">
                      Professional Information
                    </h2>
                  </div>

                  <Row>
                    <Col md={12}>
                      <div className="flex flex-col mb-5">
                        <label className="text-sm font-medium text-gray-700 mb-3">
                          Your roles in Film/TV (Select all that apply) *
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                          {[
                            "Writer",
                            "Actor",
                            "Sound Designer",
                            "Director",
                            "Editor",
                            "Film Student",
                            "Producer",
                            "Cinematographer",
                            "Other",
                          ].map((role) => (
                            <label
                              key={role}
                              className="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-gray-50 transition"
                            >
                              <input
                                type="checkbox"
                                checked={roles.includes(role)}
                                onChange={() => handleRoleChange(role)}
                                className="w-4 h-4 cursor-pointer accent-purple-500"
                              />
                              <span className="text-sm">{role}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="bio"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Bio (100 words max) *
                        </label>
                        <textarea
                          required
                          name="bio"
                          value={bio}
                          onChange={handleBioChange}
                          className="border border-gray-300 rounded-md py-2 px-3 bg-transparent outline-none resize-none focus:border-purple-500 transition"
                          rows="4"
                          placeholder="Tell us about yourself, your experience, and what you're passionate about..."
                        />
                        <small className="text-gray-500 mt-1 text-right">
                          {bio.trim() ? bio.trim().split(/\s+/).length : 0} /
                          100 words
                        </small>
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Social Media & Portfolio Card */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                  <div className="flex items-center mb-5">
                    <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 font-semibold">
                      3
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-800">
                      Social Media & Portfolio
                    </h2>
                  </div>

                  <Row>
                    <Col md={12}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="instaHandle"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Instagram Handle
                        </label>
                        <Wminput
                          type="text"
                          name="instaHandle"
                          placeholder="@username"
                          onChange={(e) => setInstaHandle(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="portfolioLink"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Portfolio Link
                        </label>
                        <Wminput
                          type="url"
                          name="portfolioLink"
                          placeholder="https://yourportfolio.com"
                          onChange={(e) => setPortfolioLink(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="workSample1"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Work Sample Link 1
                        </label>
                        <Wminput
                          type="url"
                          name="workSample1"
                          placeholder="https://youtu.be/example"
                          onChange={(e) => setWorkSample1(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="flex flex-col mb-4">
                        <label
                          htmlFor="workSample2"
                          className="text-sm font-medium text-gray-700 mb-1"
                        >
                          Work Sample Link 2
                        </label>
                        <Wminput
                          type="url"
                          name="workSample2"
                          placeholder="https://youtu.be/example"
                          onChange={(e) => setWorkSample2(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Submit Section */}
                <Row>
                  <Col md={12}>
                    <div className="text-center w-full flex items-center justify-center mb-4">
                      <ReCAPTCHA
                        sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                        onChange={onChange}
                      />
                    </div>
                    {errorMes && (
                      <div className="text-center mb-3">
                        <span className="text-red-600 text-sm">{errorMes}</span>
                      </div>
                    )}
                  </Col>
                  <Col md={12}>
                    <div className="aggrement_content my-4 text-center">
                      <small className="text-gray-600">
                        By clicking Agree & Join, you agree to the Spiral Bound{" "}
                        <a
                          href={MAIN_URL + "/legals/terms-and-conditions"}
                          className="text-blue-600 hover:underline"
                        >
                          Terms of Service
                        </a>
                        ,{" "}
                        <a
                          href={MAIN_URL + "/legals/privacy-policy"}
                          className="text-blue-600 hover:underline"
                        >
                          Privacy Policy
                        </a>
                        , and{" "}
                        <a
                          href={MAIN_URL + "/legals/cookies-policy"}
                          className="text-blue-600 hover:underline"
                        >
                          Cookie Policy
                        </a>
                        .
                      </small>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="wm-form-group flex mb-3">
                      <Wmbutton
                        className="h-12 login-btn text-lg font-semibold"
                        label={`${
                          isGettingRegister
                            ? "Creating Account..."
                            : "Agree & Join"
                        }`}
                        type="submit"
                        color="primary"
                        onClick={(e) => signUp(e)}
                        disable={isGettingRegister}
                      />
                    </div>
                  </Col>
                  {/* <Col md={12}>
                    <div className="divider-wrapper text-center my-4">
                      <p className="divider relative text-gray-500">or</p>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="wm-form-group flex mb-4">
                      <Wmbutton
                        className="h-12 login-btn flex justify-center items-center text-lg"
                        label={
                          isGoogleLogin ? (
                            <CircularProgress className="loader_size_xsm" />
                          ) : (
                            "Join with Google"
                          )
                        }
                        type="submit"
                        bordered
                        color="primary"
                        onClick={signIn}
                      >
                        <img
                          src={google}
                          alt="google"
                          className="w-5 mr-2 google_ico"
                        />
                      </Wmbutton>
                    </div>
                  </Col> */}
                  <Col md={12}>
                    <div className="already_in_out text-center mt-4">
                      <p className="mr-2 text-gray-600">
                        Already a member?{" "}
                        <a
                          href={`/login${localStorage.getItem("wm_actionURL")}`}
                          className="text-blue-600 font-semibold hover:underline"
                        >
                          Login
                        </a>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
